<div class="product-page-photos">
      <div class="content desktop container-fluid">
          <div class="see-gallery" *ngIf="photos.length > 5" (click)="openGallery()">
            <span class="material-icons">
                insert_photo
            </span>
            <span>Galeria Completa</span>
          </div>
          <div class="row">
              <div class="col-md-6 col-6 _col">
                  <div class="photo-content-one"> 
                        <div class="bg-img" [ngStyle]="{'background-image': 'url(' + photo[0].image + ')'}"></div>
                        <div class="bg-img" [ngStyle]="{'background-image': 'url(' + photo[1].image + ')'}"></div>                
                  </div>        
              </div> 
              <div class="col-md-6 col-6 _col">
                  <div class="photo-content-two">
                      <div class="section-photo">  
                          <div class="photo-item-small">
                              <div class="bg-img" [ngStyle]="{'background-image': 'url(' + photo[2].image + ')'}"></div>
                          </div>
                          <div class="photo-item-small">
                              <div class="bg-img" [ngStyle]="{'background-image': 'url(' + photo[3].image + ')'}"></div>
                          </div>    
                      </div> 
                      <div class="section-photo">
                        <div class="bg-img bg-youtube" [ngStyle]="{'background-image': 'url(' + photo[4].image + ')'}">
                            <btn-video [link]="product.link_video" *ngIf="product.ativar_video"></btn-video>
                        </div> 
                      </div>      
                  </div>  
              </div>   
          </div>
      </div>
      <div class="content mobile">
          <div class="see-gallery" *ngIf="photos.length > 1" (click)="openGallery()">
              <i class="fas fa-images"></i>
              <span>Mais fotos</span>
          </div>
          <div class="photo-content-one"> 
              <div class="bg-img bg-youtube" [ngStyle]="{'background-image': 'url(' + photoSpotlight.image + ')'}">
                  <btn-video [link]="product.link_video" *ngIf="product.ativar_video"></btn-video>
              </div>              
          </div>    
      </div>
      <div class="content-gallery" *ngIf="photos.length > 1"> 
          <galeria-light [fotos]="photos" [open]="_openGallery"></galeria-light>  
      </div>      
  </div>      
  